// Class names the canvas engine understands. Item views mark regions with these
// so they stay independent of the engine; the engine adapter maps them to its
// own conventions (React Flow happens to use the same names).

/** Grabbing here moves the item. */
export const DRAG_HANDLE = 'moot-drag'
/** Pointer gestures here never start a drag (text, buttons, inputs). */
export const NO_DRAG = 'nodrag'
/** Wheel here scrolls the element instead of panning the board. */
export const NO_WHEEL = 'nowheel'
/** Pointer gestures here never pan the board. */
export const NO_PAN = 'nopan'
